// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClientError_wrapper__4LuDT","box":"ClientError_box__sIu4A","title":"ClientError_title__NmwV8","des":"ClientError_des__uG4sn","btn":"ClientError_btn__XnXhD"};